<template>
    <div>
      <div v-if="isLoading" class="loader-overlay">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
        <div class="container-fluid">
            <div class="llp-container-section heightcontainer">
                <top-header id="height2"></top-header>
                <main-menu id="height3"></main-menu>
            <div class=" menu-margin-top">
                <div class="searchBlock row pb-4 px-3 ml-0">
                 <div class="col-sm-12 mt-3 mb-4">
                        <ul class="navLinks">
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergeCustomers') }" class="linkItem" to="/mergeCustomers">Duplicate Customers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/mergedCustomersList') }" class="linkItem" to="/mergedCustomersList">Merged Customers</router-link>
                            </li>
                            <li>
                                <router-link :class="{ active: isActiveRoute('/customerActivityLog') }" class="linkItem" to="/customerActivityLog">Activity Log</router-link>
                            </li>
                        </ul>
                    </div>
                  <div class="col-sm-12 mb-4">
                      <h3>Merge Duplicate Customers</h3>
                  </div>
                  <div class="col-lg-2">
                      <label for="fname">First Name</label>
                      <input name='fname' type="text" 
                      placeholder="First Name"
                      v-model="searchObj.firstName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="mname">Middle Name</label>
                      <input name='mname' type="text" 
                      placeholder="Middle Name"
                      v-model="searchObj.middleName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="lname">Last Name</label>
                      <input name='lname' type="text" 
                      placeholder="Last Name"
                      v-model="searchObj.lastName"
                      autocomplete="off">
                  </div>
                  <div class="col-lg-2">
                      <label for="email">Email</label>
                      <input name='email' type="email" 
                      placeholder="Email"
                      v-model="searchObj.email"
                      autocomplete="off"
                      >
                  </div>
                  <div class="col-lg-2">
                      <label for="mobile">Mobile Number</label>
                      <input name='mobile' type="text" 
                      placeholder="Mobile Number"
                      v-model="searchObj.mobile"
                      autocomplete="off"
                      maxlength="14"
                      minlength="10"
                      @input="searchObj.mobile = $event.target.value.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')"
                      >
                  </div>
                  <div class="col-lg-2 btncontainer">
                      <button  @click="searchCustomerDebounce()"
                      :disabled ="searchButtonDisable()">
                        Search
                      </button>
                  </div>
                  <div class="col-12 col-md-12">
                      <p class="clearText"><a type="button" 
                      @click="clearSearch()"
                      >Clear Search</a></p>
                  </div>
                </div>
                <div class="row tableContainer pt-5 pb-4 px-3 ml-0">
                  <div class="col-md-4 col-xl-7">
                    <h3>Customers List</h3>
                  </div>
                  <div class="col-md-5 col-xl-3 d-flex justify-content-end">
                    <!-- <div>
                    <label for="" class="filterLabel">Filter</label>
                    </div> -->
                    <div class="dropdownContainer">
    <b-dropdown id="dropdown-form" :text="''" ref="dropdown" class="filterDropdown" toggle-class="dropdownToggle">
      <template #button-content>
          <div class="d-flex flex-wrap">
            <span v-if="selectedOptions.length === 0">Select Filters</span>
            <span v-for="(option, index) in selectedOptions" :key="index" class="chip">
              {{ option }}
              <b-button size="sm" class="ml-2 p-0 btnChip" @click.stop="removeOption(option)">
                &times;
              </b-button>
            </span>
          </div>
        </template>
        <b-form-checkbox  v-model="filterOptions.firstName">First Name</b-form-checkbox>
        <b-form-checkbox  v-model="filterOptions.middleName">Middle Name</b-form-checkbox>
        <b-form-checkbox  v-model="filterOptions.lastName">Last Name</b-form-checkbox>
        <b-form-checkbox  v-model="filterOptions.email">Email</b-form-checkbox>
        <b-form-checkbox  v-model="filterOptions.mobileNumber">Mobile</b-form-checkbox>
    </b-dropdown>
  </div>
                  </div>
                  <div class="col-md-3 col-xl-2">
                    <button class="mergeButton"
                    @click="confirmMerge"
                    :disabled="this.selectedPrimary.length<=0 || selectedSecondary.length<=0"
                    >Merge Selections</button>
                  </div>
                  <div class="col-12">
                    <table class="table table-responsive mt-4 customerTable">
                      <thead class="tableHeading">
                        <tr>
                          <th style="width:10%">Customer Id</th>
                          <th style="width:14%">Name</th>
                          <th style="width:15%">Email</th>
                          <th style="width:14%">Mobile Number</th>
                          <th style="width:14%">Date of Creation</th>
                          <th style="width:10%">Customers to Keep</th>
                          <th style="width:10%">Customers to Merge</th>
                          <!-- <th style="width:14%">Action</th> -->
                        </tr>
                      </thead>
                      <template>
                      <tbody v-if="customerList.length>0">
                        <tr v-for="(customer,index) of customerList" :key="customer.customerId" :class="{
                          'dark-border': isNewFirstName(index)}">
                          <td class="tableCustomerId align-middle">{{customer.customerId}}</td>
                          <td class="tableName align-middle">{{customer.firstName + ' '+ customer.middleName + ' ' + customer.lastName}}</td>
                          <td class="tableEmail align-middle">{{customer.digitalContactInfo.email}}</td>
                          <td class="tableMobile align-middle">{{customer.digitalContactInfo.mobileNumber.replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')}}</td>
                          <td class="tableDate align-middle">{{customer.createdDate}}</td>
                          <td class="text-center align-middle">
                            <input  type="checkbox" id="keep" 
                            v-model="selectedPrimary" 
                            :value="customer.customerId"
                            @change="handleKeepChange(index)"
                            :disabled="primaryColumnDisabled && !selectedPrimary.includes(customer.customerId) || selectedSecondary.includes(customer.customerId)"
                            >
                          </td>
                          <td class="text-center align-middle">
                            <input  type="checkbox" id="merge"
                            v-model="selectedSecondary" 
                            :value="customer.customerId"
                            :disabled="selectedPrimary.includes(customer.customerId)"
                            >
                          </td>
                          <!-- <td><button></button></td> -->
                        </tr>
                      </tbody>
                      <tbody v-else class="text-center">
                        {{noResult}}
                      </tbody>
                      </template>

                    </table>
                  </div>
                </div>
              </div>
              <div class="mt-5 mb-5 pb-3">
                    <b-pagination align="center" v-if="rows>perPage && customerList.length>0"
                     v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    first-number
                    last-number
                    @input="pagination"
                    class="customPagination"
                    ></b-pagination>
                </div>
                <!--confirm merge customer-->
        <div @click.self="isMergeConfirm = false" v-if="isMergeConfirm" class="modal" id="mergeSelect">
          <div class="modal-content">
            <div class="modal-heading">
              <h4>Merge Customers</h4>
            </div>
            <div class="modal-body">
              <img src="../assets/question.jpg" alt="" class="logo mt-2" />
              <p class="modalText mt-3 mb-4">
                Are you sure, Do you want to merge customers ?
              </p>
              <!-- <img src="../assets/question.jpg" alt=""> -->
              <div class="d-flex justify-content-center mt-2 mb-1">
              <button
                type="button"
                class="btn mergeButton mx-2"
                @click="merge()"
              >
                Merge
              </button>
              <button type="button" @click="isMergeConfirm = false"  class="btn yesButton mx-2">Cancel</button>
              </div>
              
            </div>
          </div>
        </div>
        <!--confirm merge customer-->
        <!--successful merge dialog code start-->
        <div v-if="isSuccess" class="modal" id="successModal" @click.self="closeSuccess()">
          <div class="modal-content">
            <div class="modal-body">
              <img src="../assets/checkicon-min.png" alt="" class="logo" />
              <p class="modalText">
              {{mergeSuccess}}
              </p>
            </div>
          </div>
        </div>
        <!--successful merge dialog code end-->
            <bottom-footer></bottom-footer>
            </div>
        </div>
    </div>
</template>
<script>
import TopHeader from "@/components/TopHeader.vue";
import MainMenu from "@/components/Menu.vue";
import BottomFooter from "@/components/BottomFooter.vue";
import httpcommon from "../js/http-common.js";
import httpCommon from '../http-common.js';
import moment from 'moment';
import debounce from 'lodash/debounce';

export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter,
  },
  name: "mergeCustomerData",

data() {
  return {
    selectedPrimary: [],
    selectedSecondary: [],
    mergeDisabled: [],
    searchObj : {
        firstName: '',
        middleName: '',
        lastName: '',
        email: '',
        mobile: ''
        },
    customerList: [],
    currentPage: 1,
    rows: 0,
    perPage: 10,
    isMergeConfirm: false,
    isLoading: false,
    isSuccess: false,
    mergeSuccess: '',
    noResult: '',
    isSearch: false,
    filterOptions: {
    firstName: false,
    middleName: false,
    lastName: false,
    email: false,
    mobileNumber: false,
    isClearingFilters: false,
    }
  }
},
watch: {
    searchObj: {
      handler(newVal) {
        // if (newVal.mobile && !/^\d{0,10}$/.test(newVal.mobile)) {
        //   this.searchObj.mobile = newVal.mobile.replace(/\D/g, '');
        //   return; 
        // }
        const allFieldsCleared = !newVal.firstName.trim() &&
                                 !newVal.middleName.trim() &&
                                 !newVal.lastName.trim() &&
                                 !newVal.email.trim() &&
                                 !newVal.mobile ;

        const isMobileNumeric = newVal.mobile.trim() ? /^\d*$/.test(newVal.mobile.trim()) : true;

      if (allFieldsCleared && this.isSearch) {
        this.selectedPrimary = []
        this.selectedSecondary = []
        this.currentPage = 1
        this.getCustomerList();
      }else if (!isMobileNumeric) {
        // Prevent calling getCustomerList if mobile field has non-numeric input
        return;
      } }, // Adjust the debounce delay as needed
      deep: true,
    },

    filterOptions: {
      handler () {
        if (!this.isClearingFilters) {
        this.currentPage = 1
        this.selectedPrimary = []
        this.selectedSecondary = []
        this.getCustomerList()
        }
      },
      deep: true
    }
  },
computed: {
  primaryColumnDisabled () {
      return this.selectedPrimary.length>0
    },
    selectedOptions() {
      return Object.keys(this.filterOptions)
        .filter(key => this.filterOptions[key])
        .map(key => this.formatOptionLabel(key));
    }
},
methods: {
  formatOptionLabel(key) {
      const labels = {
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        email: 'Email',
        mobileNumber: 'Mobile'
      };
      return labels[key];
    },
    removeOption(option) {
      const key = Object.keys(this.filterOptions).find(key => this.formatOptionLabel(key) === option);
      if (key) {
        this.filterOptions[key] = false;
      }
    },
  handleKeepChange(index) {
    // console.log(this.selectedPrimary[index],'selectedPrimary')
      if (this.selectedPrimary.includes(this.customerList[index].customerId)) {
        // Uncheck the checkbox and re-enable all
        this.disableSecondaryColumn(index)
      }
    },
    clearFilterOptions() {
    this.filterOptions.firstName = false;
    this.filterOptions.middleName = false;
    this.filterOptions.lastName = false;
    this.filterOptions.email = false;
    this.filterOptions.mobileNumber = false;

    // Reset the flag after clearing
    this.$nextTick(() => {
        this.isClearingFilters = false;
    });
},
    disableSecondaryColumn (index) {
      const Id = this.customerList[index].customerId
      const secondaryIndex = this.selectedSecondary.indexOf(Id)
      if(secondaryIndex > -1) {
        this.selectedSecondary.splice(secondaryIndex,1)
      }
    },
    confirmMerge () {
      this.isMergeConfirm = true
    },
    merge () {
      let mergeData = {
        customerToKeepId: this.selectedPrimary[0],
        customersToMergeIDs: this.selectedSecondary,
        customerToKeep: {
        firstName: "",
        middleName: "",
        lastName: "",
        digitalContactInfo: {
            email: "",
            mobileNumber: ""
          }
        }}
      httpcommon
      .put('/customer/mergeCustomers',mergeData)
      .then(response=>{
        this.isMergeConfirm = false
        this.isSuccess = true
        this.mergeSuccess = response.data
        setTimeout(()=>{this.isSuccess=false
          this.clearSearch()
          this.getCustomerList()
        },2000)
        this.selectedPrimary = []
        this.selectedSecondary = []
        // this.clearSearch()
      }).catch(error=>{
        console.log(error,'error')
      })
    },

    searchCustomerDebounce () {
      this.currentPage = 1
      this.selectedPrimary = []
      this.selectedSecondary = []
      this.isClearingFilters = true;  // Set the flag before clearing filters
      this.clearFilterOptions(); 
      this.searchCustomer()
    },
    
  searchCustomer () {
    this.isLoading = true
    this.noResult = ''
    let searchParams = new URLSearchParams();
  if (this.searchObj.firstName) {
    searchParams.append('firstName', this.searchObj.firstName);
  }
  if (this.searchObj.middleName) {
    searchParams.append('middleName', this.searchObj.middleName);
  }
  if (this.searchObj.lastName) {
    searchParams.append('lastName', this.searchObj.lastName);
  }
  if (this.searchObj.email) {
    searchParams.append('email', this.searchObj.email);
  }
  if (this.searchObj.mobile) {
    searchParams.append('mobile', this.searchObj.mobile.replace(/\D/g, ''));
  }
    this.customerList = []
    httpcommon
    .get(`/customer/filterCustomerList?${searchParams.toString()}&page=${this.currentPage-1}&size=${this.perPage}`)
    .then(response=>{
      this.isLoading = false
      this.isSearch = true
      if (response.data.content.length>0) {
      this.customerList = response.data.content
      
      this.customerList.forEach(customer=>{
        customer.createdDate = moment(customer.creationD).format('Do MMM, YYYY');
      })
      this.rows = response.data.totalElements
      } else {
        this.noResult = 'No Result Found'
      }
    }).catch(error=>{
      this.isLoading = false
      this.errorslist.push(error)
    })
  },
  clearSearch () {
    const isSearch = this.searchObj.firstName== '' && this.searchObj.middleName== '' && this.searchObj.lastName== '' && this.searchObj.email== '' && this.searchObj.mobile== ''
      if (!isSearch) {
      this.searchObj.firstName= '',
      this.searchObj.middleName= '',
      this.searchObj.lastName= '',
      this.searchObj.email = '',
      this.searchObj.mobile= ''
      // this.customerList = []
      this.currentPage = 1
      this.noResult = ''
      this.selectedPrimary = []
      this.selectedSecondary = []
      // this.getCustomerList()
      }
    },
  searchButtonDisable () {
      // return  (!this.searchObj.firstName.trim() && !this.searchObj.middleName.trim() && !this.searchObj.lastName.trim() && !this.searchObj.email && !this.searchObj.mobile)
  //     const allFieldsEmpty = !this.searchObj.firstName.trim() && 
  //                        !this.searchObj.middleName.trim() && 
  //                        !this.searchObj.lastName.trim() && 
  //                        !this.searchObj.email.trim() && 
  //                        !this.searchObj.mobile.trim();
  
  // const isEmailValid = this.searchObj.email.trim() ? this.isValidEmail() : true;
  
  // const isMobileValid = /^\d{10}$/.test(this.searchObj.mobile.trim());
  // return allFieldsEmpty || !isEmailValid || !isMobileValid;

  const isFirstNameFilled = this.searchObj.firstName.trim() !== '';
  const isMiddleNameFilled = this.searchObj.middleName.trim() !== '';
  const isLastNameFilled = this.searchObj.lastName.trim() !== '';

  // Check if the email is valid or if it's empty
  const isEmailValid = this.searchObj.email.trim() ? this.isValidEmail() : true;

  // Check if the mobile field is valid (only numeric and 10 digits long) or if it's empty
  const isMobileValid = this.searchObj.mobile.trim() ? /^\d{10}$/.test(this.searchObj.mobile.trim().replace(/\D/g, '')) : true;

  // Disable the button if all fields are empty, or if email/mobile are invalid
  const isAnyFieldFilled = isFirstNameFilled || isMiddleNameFilled || isLastNameFilled || this.searchObj.email.trim() || this.searchObj.mobile.trim();

  return !isAnyFieldFilled || !isEmailValid || !isMobileValid;
  },
  isValidEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.searchObj.email.trim());
    },
    isValidMobile() {
      if(this.searchObj.mobile) {
      const mobilePattern = /^[0-9]{10}$/; // Adjust the regex according to the required format
      return mobilePattern.test(this.searchObj.mobile);
      }
    },
  getCustomerList () {
    this.isSearch = false
    this.isLoading = true
    this.customerList = []
    this.noResult = ''
    this.searchObj.firstName= '',
    this.searchObj.middleName= '',
    this.searchObj.lastName= '',
    this.searchObj.email = '',
    this.searchObj.mobile= ''
    let filterParams = new URLSearchParams()
    if (this.filterOptions.firstName) {
      filterParams.append('firstName',true)
    }
    if (this.filterOptions.middleName) {
      filterParams.append('middleName',true)
    }
    if (this.filterOptions.lastName) {
      filterParams.append('lastName',true)
    }
    if (this.filterOptions.email) {
      filterParams.append('email',true)
    }
    if (this.filterOptions.mobileNumber) {
      filterParams.append('mobile',true)
    }
    let anySelected = false
    for(const [key,value] of Object.entries(this.filterOptions)) {
      if(value==true) {
        anySelected = true
      }
    }
    if (!anySelected) {
      filterParams.append('firstName',true)
      filterParams.append('email',true)
    }
    httpcommon.get(`/customer/getAllCustomerList?${filterParams}&page=${this.currentPage-1}&size=${this.perPage}`).then(response=>{
      this.isLoading = false
      if (response.data.content.length>0) {
      this.customerList = response.data.content
      this.customerList.forEach(customer=>{
        customer.createdDate = moment(customer.creationD).format('Do MMM, YYYY');
      })
      console.log(this.customerList[0].createdDate)
      this.rows = response.data.totalElements
      }
    }).catch(error=>{
      this.isLoading = false
      this.errorslist.push(error)
    })
  },
  pagination () {
    const checkProp = !this.searchObj.firstName.trim() && !this.searchObj.middleName.trim() && !this.searchObj.lastName.trim() && !this.searchObj.email.trim() && !this.searchObj.mobile.trim()
    if (!checkProp && this.isSearch) {
      this.searchCustomer()
    } else {
      this.getCustomerList()
    }
  },
  isNewFirstName(index) {
      // if (index === 0) return true; // Always apply border for the first row
      const currentCustomer = this.customerList[index];
      const previousCustomer = this.customerList[index - 1];
      if (!currentCustomer || !previousCustomer) return false;

       const anySelected = Object.values(this.filterOptions).some(value => value === true);

  if (!anySelected) {
    // If no filters are selected, only compare by firstName
    return currentCustomer.firstName !== previousCustomer.firstName;
  }
// if(this.filterOptions.firstName)
//      return currentCustomer.firstName !== previousCustomer.firstName;
const fieldsAreSame = Object.keys(this.filterOptions).every(field => {
        if (this.filterOptions[field]) {
          if (field === 'email') {
        return currentCustomer.digitalContactInfo.email === previousCustomer.digitalContactInfo.email;
      } else if (field === 'mobileNumber') {
        return currentCustomer.digitalContactInfo.mobileNumber === previousCustomer.digitalContactInfo.mobileNumber;
      } else {
        return currentCustomer[field] === previousCustomer[field];
      }
        }
        return true;
      });
      // If any of the selected fields differ, return true to apply the border
      return !fieldsAreSame;
  },
  isActiveRoute(route) {
      return this.$route.path === route
    },
retrieveData: function () {
      httpcommon
        .get("/userrole/")
        .then((response) => {
          this.userroles = response.data
        })
        .catch((e) => {
          console.log(e);
          this.errorslist.push(e);
        });
      httpcommon
        .get("/staticdata/status/")
        .then((response) => {
          this.status = response.data
        })
        .catch((e) => {
          this.errorslist.push(e)
        });
    },
    myFunction() {
      var elmnt = document.getElementById("height2");
      var elmnt1 = document.getElementById("height3");
      var txt = elmnt.offsetHeight;
      var width = elmnt.offsetWidth;
      var txt1 = elmnt1.offsetHeight;
      var ht = txt + txt1;
      $("#employee").css("margin-top", txt + txt1 + 3);
    },
    menuheight () {
      var elmnt = document.getElementById("height2");
      var txt = elmnt.offsetHeight;
      $('#height3').css('margin-top', txt)
    }
},
created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.myFunction()
    this.menuheight()
    this.getCustomerList()
  },
  beforeDestroy () {
    // document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>
<style scoped >
.searchBlock {
  background-color: #F2F9FF;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  width: 100%;
}
.searchBlock h3 {
  font-weight: 600;
  color: #000000;
  line-height: 37.24px;
}
.searchBlock label {
  font: 400;
  font-size: 14px;
  color: #1C1B1F;
}
.searchBlock input {
  font: 400;
  font-size: 16px;
  color: #1C1B1F;
  border: 1px solid #E4ECF4;
  border-radius: 8px;
  padding: 10px;
  height: 44px;
  width: 100%;
}
/* .searchBlock input::placeholder {
color: #C5C5C5;
} */
.searchBlock button {
  border-radius: 8px;
  color: #FFFFFF;
  font-weight: 600;
  font-size: 18px;
  background-color: #1E90FF;
  padding: 10px;
  height: 44px;
  width: 160px;
  border: none;
  width: 100%;
}
.btncontainer {
  padding-top: 30px;
}
 button:disabled {
  background-color: #9B9B9B !important;
  /* color: #000000; */
  /* cursor: none; */
}
.clearText {
  text-align: end;
  /* padding-right: 25px; */
  margin: 0;
}
.clearText a {
  cursor: pointer;
  color: #91a7bd ;
  font-weight: 400;
  font-size: 13px;
  text-decoration: underline;
}
.clearText a:hover {
  
  color: #1e90ff;
}
.tableContainer {
    width: 100%;
    /* overflow-x: auto; */
}
.tableContainer h3 {
  font-size: 24px;
  font-weight: 600;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.tableContainer .mergeButton {
  background: #1E90FF ;
  border-radius: 8px;
  padding: 10px;
  width: 100%;
  color: #FFFFFF;
  border: none;
  font-weight: 600;
  height: -webkit-fill-available;
}
/* .customerTable {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
  table-layout: fixed;
} */
.customerTable thead tr {
  color: #9B9B9B;
  font: 600 14px 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 32px;
}
/* .customerTable thead tr th {
    border-top: none;
} */
/* .customerTable tbody tr td {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
} */
tbody tr {
  border-bottom: 1px solid #dbdbdb;
}
.customerTable .tableName {
  font-weight: 600;
  font-size: 16px;
}
.customerTable {
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    line-height: 32px;
    table-layout:auto;
    width: 100%;
}
.customerTable thead tr th {
    border-top: none;
    white-space: nowrap; /* Prevent header text from wrapping */
}
.customerTable tbody tr td {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    white-space: nowrap; /* Prevent cell text from wrapping */
}
@media only screen and (max-width: 768px) {
    .customerTable {
        table-layout: auto; /* Allow table to adapt to screen width */
    }
}
.dark-border {
  border-top: 2px solid #1E90FF !important; /* Adjust thickness and color as needed */
}
.customPagination ::v-deep .page-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
}
.customPagination ::v-deep .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none ;
  height: 30px;
  width: 30px;
  margin: 0;
  padding: 10px;
  font-size: 20px;
  color: #9B9B9B;
}
.customPagination ::v-deep .active .page-link {
  background-color: #005DF1;
  border-radius: 8px;
  color: #FFFFFF;
}

.pagination.customPagination ::v-deep .page-item:first-child .page-link,
.pagination.customPagination ::v-deep .page-item:last-child .page-link {
  font-size: 40px !important; /* Adjust the font size as needed */
  padding: 0 20px 10px 20px;
}
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-heading {
  font-size: 14px;
}
.modal-heading::after {
  content:' ';
  height: 1px;
  background: #9B9B9B;
  width: 100%;
  display: block
}
.modal-content {
  border: #ffffff;
  background-color: #ffffff;
  padding: 36px 40px 36px 40px !important;
  width: 70vh !important;
  height: auto !important;
  max-height: 70vh;
  border-radius: 16px;
  text-align: center;
}
.modalText {
  font-size: 18px;
  font-weight: 400;
  line-height: 26.6px;
  color: #000000;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.modal-body img {
  height:70px
}
.mergeButton,.yesButton {
  background-color: #1E90FF;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.28px;
  padding: 10px 20px;
  border-radius: 8px;
  /* margin: auto; */
}
.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loader {
  border: 12px solid #f3f3f3;
  border-top: 12px solid #3498db;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.notFound {
  display: flex;
  /* width: 100% !important; */
  text-align: center;
  margin: auto;
}
.navLinks {
    list-style: none;
    display: flex;
    padding-left: 0;
    justify-content: center;
}
.navLinks li {
    padding: 10px 35px 10px 0px;
}
.linkItem {
font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
font-size: 18px;
font-weight: 600;
color: #8C8C8C;
Padding:10px 30px 10px 30px;
border-radius: 8px;
}
.linkItem:hover {
    color: #FFFFFF;
    background-color: #1E90FF;
}
.navLinks .active {
color: #FFFFFF !important;
background-color: #1E90FF;
}
.filterLabel {
  padding: 7px;
  margin: 0;
  margin-top: 6px;
  color: #1C1B1F;
  font-size: 14px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.dropdownContainer {
  width: 100%;
}
@media only screen and (min-width: 1201px) {
.dropdownContainer {
  width: 90%;
}
}
.b-dropdown {
  width: 100%;
  height: 46px;
  max-height: 46px;
}
 .filterDropdown ::v-deep .dropdown-toggle  {
  border-radius: 8px !important;
  border-color: #BAC1C8;
  background-color: #FFFFFF !important;
  color: #8A8A8A;
  font-weight: 400;
  font-size: 16px;
  line-height: 32px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: start;
  padding: 0px 0px 0px 12px;
}
.filterDropdown ::v-deep .dropdown-toggle::after {
  position: absolute;
  top: 20px;
  right: 13px;
}
.filterDropdown ::v-deep .dropdown-menu {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  min-width: 18rem !important;
  border: none;
  /* border-radius: 8px; */
  box-shadow: -4px 6px 25.6px 0px #00000021;
  padding: 12px 8px 12px 8px;
  z-index: 1;
}
.filterDropdown ::v-deep .custom-control {
padding: 16px 12px 16px 12px;
}
.filterDropdown ::v-deep .custom-control-input {
  position: relative;
}
/* .filterDropdown ::v-deep .custom-control:hover {
  background-color:#dbdbdb;
} */
.filterDropdown ::v-deep .custom-control-label {
  padding-left: 16px !important;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
}
.filterDropdown {
  width: 100%;
}

.dropdownToggle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.chip {
  display: flex;
  align-items: center;
  background-color: #e1e1e1;
  border-radius: 12px;
  padding: 2px 8px;
  margin-right: 4px;
  margin-bottom: 4px;
  font-size: 10px;
  height: 20px;
  width: auto;
  max-width: 90px;
}

 .chip btn-outline-danger  {
  font-size: 12px !important;
  margin-left: 4px;
  padding: 0;
  color: #000000 !important;
  background: none !important;
  border: none;
  height: 20px !important;
}
.chip btn-outline-danger:hover {
  background-color: none !important;
}
.chip-remove:hover {
  color: #333; /* Darker color on hover */
  background-color: transparent !important; /* Ensure no background color */
  border-radius: 50%; /* Circular button */
}
.btnChip {
  background-color: transparent !important;
  color:#000000;
  border: none;
}
</style>